<template>
  <div>
    <portal to="toolbar-title"> Αναλυτικές κινήσεις</portal>
    <v-card v-if="partners">
      <v-row dense>
        <v-col lg="2" style="border-right:1px solid #b2b2b2;">
          <v-card flat>
            <v-toolbar flat>
              <v-toolbar-title style="font-weight: bolder; font-size: 1.5em;"> Eπιλογή Πελάτη</v-toolbar-title>
            </v-toolbar>
            <v-list class="overflow-y-auto" color="transparent" :max-height="!isMobile?'80vh':''">
              <v-list-item-group :value="activePartner" mandatory>
                <v-list-item @click="partnerClick(index)" link
                             v-for=" (partner,index) in partners">
                  <v-list-item-content>
                    <v-list-item-subtitle v-tooltip="partner.PartnerBrandName">{{ partner.PartnerBrandName }}</v-list-item-subtitle>
                    <v-list-item-title>{{ partner.PartnerInvAddress }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
        <v-col lg="10" v-if="!isMobile">
          <v-toolbar flat style="border-bottom:1px  #e3e3e3 solid; ">
            <v-toolbar-title style="font-weight: bolder; font-size: 1.1em;">
              Αναλυτικές κινήσεις: {{ partners[activePartner].PartnerFullName }}
            </v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
          <div class="pa-4">
            <partner-dept-moves v-if="activePartner || activePartner === 0 "
                                :partner-name="partners[activePartner].PartnerFullName"
                                :partner-id="partners[activePartner].Partner_ID"/>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog fullscreen v-if="isMobile" v-model="showModal">
      <v-card>
        <v-app-bar v-if="showModal" fixed tile elevate-on-scroll dark color="secondary">
          <v-toolbar-title> {{ partners[activePartner].PartnerFullName }}</v-toolbar-title>
          <v-spacer/>
          <v-btn icon @click="showModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-sheet style="padding-top:55px;">
          <partner-dept-moves v-if="activePartner || activePartner === 0 "
                              :partner-name="partners[activePartner].PartnerFullName"
                              :partner-id="partners[activePartner].Partner_ID"/>
        </v-sheet>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import store from "../../../store";
import dataGridHandler from "../../../wl-datagrid-handler/dataGridHandler";
import moment from 'moment';
import {mapActions, mapGetters, mapMutations} from "vuex";
import PartnerDeptMoves from "../components/PartnerDeptMoves";
import Expandable from "../../../wl-core/components/Expandable";
import backButton from "@/wl-core/mixins/backButton";

export default {
  name: "DeptMoves",
  components: {Expandable, PartnerDeptMoves},
  mixins: [backButton(['showModal'])],
  data: () => ({
    activePartner: 0,
    options: {},
    showModal: false,
    headers: [
      {
        text: 'Hμ/νια ',
        value: 'Hmerom',
        filterable: true,
        width: "100"
      },
      {
        text: '# Παρ.',
        value: 'NumberPar',
        filterable: true,
        width: "50"
      },
      {
        text: 'Περιγραφή',
        value: 'InvoiceDescr',
        filterable: true,
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        filterable: true,
      },
      {
        text: 'Κτήριο',
        value: 'BranchAddress',
        filterable: true,
        width: "200"
      },
      {
        text: 'Πελάτης',
        value: 'Partner_ID',
      },
      {
        text: 'Ποσό',
        value: 'Balance',
        filterable: true,
        width: "100"
      },
    ]
  }),
  created() {
    this.showLoading();
    this.getPartnerDetails().then(resp => {
      if (this.isMobile) this.activePartner = 0;
      this.hideLoading();
    })
  },
  computed: {
    ...mapGetters([
      "partners",
      "deptMoves",
      "isMobile",
    ]),

  },
  methods: {
    ...mapActions(
        ["getPartnerDetails"]
    ),
    partnerClick(index) {
      this.activePartner = index
      if (this.isMobile) {
        this.showModal = true
      }
    },
    ...mapMutations([
      "showLoading",
      "setLoadingMessage",
      "hideLoading",
    ]),


  }
}
</script>

<style scoped>

</style>
